var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "289px",
    height: "277px",
    viewBox: "0 0 289 277",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6403 0.304923C20.5082 0.784739 21.9316 1.11604 22.1515 1.79578C22.6607 3.43515 23.4128 5.8171 22.6491 6.89668C18.3443 12.8258 12.1474 16.2131 4.99585 17.5383C3.5204 17.8068 0.737314 16.2588 0.199212 14.9165C-0.379393 13.4599 0.367007 10.4382 1.60522 9.53567C6.39607 6.07985 11.5804 3.13812 16.7126 0.156409C17.4185 -0.243438 18.6509 0.24209 19.6403 0.304923",
    transform: "translate(0 259.29895)",
    id: "Fill-138",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87981 0C8.06117 0.45536 10.3097 1.02894 10.279 1.3617C9.75197 6.21742 7.16527 10.6659 7.44633 15.7143C6.00147 15.7056 4.04717 16.2923 3.20397 15.5786C-2.37346 10.8236 -0.366465 2.67962 6.87981 0",
    transform: "translate(277.99805 242.89368)",
    id: "Fill-145",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8004 0C12.2463 3.1378 12.5102 7.1869 12.1666 11.433C11.8878 14.8713 8.15305 16.9304 4.78186 15.5068C-0.172848 13.4083 -1.7464 6.60564 2.31198 3.39888C4.16439 1.93588 6.89321 1.57136 9.22865 0.704405L8.8004 0",
    transform: "translate(41.4541 0)",
    id: "Fill-154",
    fill: "#9FA2A1",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg19);
export default __webpack_public_path__ + "static/media/19.eafede8e824757b7217ba90b4779945f.svg";
export { ForwardRef as ReactComponent };